import { RootReducerState } from '../index';

export const selectPromo = (state: RootReducerState): string => state.onboardingReducer.promo;
export const selectAiChatPrompt = (state: RootReducerState): string => state.onboardingReducer.aiChatPrompt;
